import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import MuiButton from "@material-ui/core/Button";
import colors from "../../config/colors";

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: ({ regular }) =>
      [!regular ? "Gibson SemiBold" : "Gibson", "sans-serif"].join(","),
    borderColor: colors.shuttleGray,
    fontSize: 14,
    padding: theme.spacing(2),
    lineHeight: 1.2,
    textTransform: "inherit",
    minWidth: 50
  },
  containedPrimary: {
    background:
      "transparent linear-gradient(122deg, #65DFFF 0%, #56CEF8 100%, #55CCF7 100%) 0% 0% no-repeat padding-box",
    boxShadow: "0px 1px 12px #00000014",
    border: "1px solid #8AFAFF",
    "&.Mui-disabled": {
      background: theme.palette.action.disabledBackground,
      border: "none",
      boxShadow: "none"
    }
  }
}));

const Button = React.forwardRef(
  ({ disabledClassName, regular, ...props }, ref) => {
    const classes = useStyles({ regular });

    return (
      <MuiButton
        ref={ref}
        classes={{
          root: classes.root,
          containedPrimary: classes.containedPrimary,
          disabled: disabledClassName
        }}
        {...props}
      />
    );
  }
);

Button.propTypes = {
  disabledClassName: PropTypes.string,
  regular: PropTypes.bool
};

Button.defaultProps = {
  disabledClassName: null,
  regular: false
};

export default Button;
